import ArticleDetail from 'New/article-detail'

export default ArticleDetail
